import React from "react";
import DOMPurify from "dompurify";

export default class YoutubeVideoCtrl extends React.Component {

    sanitizeHtml(value) {
        return DOMPurify.sanitize(value || '');
    }

    sanitizeText(value) {
        return DOMPurify.sanitize(value || '', { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
    }

    render() {
        const { id, src, title, subtitle, description, background } = this.props;
        const titlePart = this.renderTitle(title);
        const style = background && {
            background
        }
        
        return (
            <div id={id} className='pubhub-single-video' style={style}>
                {titlePart}
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="pubhub-single-video-iframe-container">
                                <iframe src={src} allowFullScreen={true}></iframe>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div>
                                <div className="pubhub-single-video-subtitle">{this.sanitizeText(subtitle)}</div>
                                <div className="pubhub-single-video-desc">{this.sanitizeText(description)}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    renderTitle(title) {
        if(!title) {
            return null;
        }

        return (
            <div className="container">
                <div className="pubhub-single-video-title">{this.sanitizeText(title)}</div>
            </div>
        );
    }
}
